<script>
    import { onMount } from 'svelte';
    import { fetchTwoFaChallenge, sendTwoFaChallenge } from '/public/services/users/users';
    import { ShieldCheck } from 'svelte-bootstrap-icons';

    export let currentRoute;

    let hash = currentRoute.namedParams.hash;
    let loading = true;
    let name = null;
    let otp = null;

    function challengeOTP(e) {
        e.preventDefault();
        sendTwoFaChallenge(hash,otp).then(res => {
            if (res.success) {
                window.location = res.data.url;
            }
        });
    }

    onMount(() => {
        fetchTwoFaChallenge(hash).then(res => {
            if (res.success) {
                name = res.data.name;
                loading = false;
            } else {
                window.location = '/';
            }
        });
    });
</script>



{#if loading === true}

    <div class="text-center">
        <h5>
            <ShieldCheck/> Checking your authentication permissions....
        </h5>
    </div>

{:else}

    <div class="row justify-content-center mt-3">
        <div class="col-sm-12 col-md-6 col-lg-5">
            <div class='mb-3 text-center'>
                <img 
                    src='/images/Black.png' 
                    class='img-fluid mx-auto thexa-logo' 
                    alt='THEXA'
                />
            </div>            
            <div class="card">
                <div class="card-header text-bg-primary">
                    <ShieldCheck/> Two factor authentication challenge
                </div>
                <div class="card-body">
                    <p>
                        We need to confirm your 2FA setup in your authenticator app<br/>
                        Enter the OTP code from your authenticator app in the form below.<br/>
                    </p>
                    <form class="form" on:submit={challengeOTP}>
                        <div class="row mb-3">
                            <label class="col-sm-2 col-form-label" for="otp_code">
                                OTP
                            </label>
                            <div class="col-sm-8">
                                <input type="text" id="otp_code" class="form-control" required bind:value={otp} placeholder="Enter your OTP code"/>
                            </div>
                            <div class="col-sm-2">
                                <div class='d-grid'>
                                    <button type="submit" class="btn btn-primary">
                                        
                                        Ok
                                        
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

{/if}

<style>    
    .thexa-logo {
        max-width: 35%;
        height: auto;
    }    
</style>
